import $ from 'jquery';
import {connectClearRefinements} from 'instantsearch.js/es/connectors';

const renderCustomClearRefinements = (renderOptions, isFirstRender) => {
    const {refine, widgetParams, hasRefinements} = renderOptions;

    if (isFirstRender) {
        widgetParams.container.addEventListener('click', () => {
            if ($('.algolia-chosen-filter[data-attribute="departmentName"]').length > 0) {
                sessionStorage.setItem('genderPreSelection', '');
            }
            refine();
        });
    }

    if (hasRefinements) {
        widgetParams.container.classList.replace('d-none', 'd-flex');
    } else {
        widgetParams.container.classList.replace('d-flex', 'd-none');
    }

};

const customClearRefinements = connectClearRefinements(
    renderCustomClearRefinements
);

export {customClearRefinements};
